import router from './index'
import store from '@/store'
// 路由守卫
router.beforeEach((to, from, next) => {
  let sessionStorage = window.sessionStorage
  let routersArr =
    (sessionStorage.getItem('routers') &&
      sessionStorage.getItem('routers').split(',')) ||
    []

  if (routersArr.length == 0) {
    routersArr.push(from.name)
    routersArr.push(to.name)
  } else {
    if (routersArr.indexOf(to.name) != -1) {
      routersArr.splice(routersArr.indexOf(to.name) + 1, 100)
      if (to.name !== from.name) {
        setTimeout(() => {
          document.body.scrollTop = to.meta.scrollTop
          document.documentElement.scrollTop = to.meta.scrollTop
        }, 400)
        console.log('---------------scrollop', to.meta.scrollTop)
      }
    } else {
      // 前进
      // debugger
      if (document.documentElement && document.documentElement.scrollTop) {
        from.meta.scrollTop = document.documentElement.scrollTop
      } else if (document.body) {
        from.meta.scrollTop = document.body.scrollTop
        console.log('---------------scrollop', document.body.scrollTop)
      }
      document.body.scrollTop = 0
      document.documentElement.scrollTop = 0
      routersArr.push(to.name)
    }
  }
  //首页保活
  if (
    !routersArr.some(e => {
      return e == 'TabbarHome'
    })
  ) {
    routersArr.unshift('TabbarHome')
  }
  sessionStorage.setItem('routers', routersArr.join(','))
  // store.state.includes = routersArr
  store.commit('updateIncludes', routersArr)
  next()
})
